 /* eslint-disable */
import React, { useState, useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import { useDispatch, useSelector } from 'react-redux'
import { createProduct, updateProduct } from '../../actions/productActions'
import { useSnackbar } from 'react-simple-snackbar'
import useAuthUser from '../../hooks/useAuthUser'

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: '#1976D2',
    marginLeft: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const AddProduct = ({ setOpen, open, currentId, setCurrentId }) => {
    const location = useLocation()
    const [productData, setProductData] = useState({ brand: '', modelNumber: '', cost: '', price: '', type: '', description: '', userId: [] })
    const authData = useAuthUser()
    const dispatch = useDispatch()
    const product = useSelector((state)=> currentId ? state.products.products.find((c) => c._id === currentId) : null)
    // eslint-disable-next-line 
    const [openSnackbar, closeSnackbar] = useSnackbar()

    useEffect(() => {
      if(product) {
        setProductData(product)
      }
    }, [product])

    useEffect(() => {
      const userId = authData?.result?._id || authData?.result?.googleId
      if(userId) {
        setProductData((prev) => ({...prev, userId: [userId]}))
      }
    },[location, authData])

  const formatDollarsToCents = function (value) {
      value = `${value}`.replace(/[^\d.-]/g, '');
      if (value && value.includes('.')) {
          value = value.substring(0, value.indexOf('.') + 3);
      }
  
      return value ? Math.round(parseFloat(value) * 100) : 0;
  };
  
  const formatCentsToDollars = function (value) {
      value = `${value}`.replace(/[^\d.-]/g, '');
      value = parseFloat(value);
      return value ? value / 100 : 0;
  };
  
  // Create our number formatter.
  const dollar_formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
  });

    const handleSubmitProduct =(e)=> {
        e.preventDefault()
        console.log(productData)
        if(currentId) {
          dispatch(updateProduct(currentId, productData, openSnackbar))       
        } else {
          if (productData.brand !== '' && productData.modelNumber !== '') {
            dispatch(createProduct(productData, openSnackbar))
          } else {
            openSnackbar('Product not added. Brand or Model Number empty.')
          }
          
        }
        handleClose()
    }

  const clear =() => {
    setCurrentId(null) 
    setProductData({ brand: '', modelNumber: '', cost: '', price: '', type: '', description: '', userId: [] })
  }
    
  const handleClose = () => {
    setOpen(false);
    clear();
  };

  const inputStyle = {
    display: "block",
    padding: "1.4rem 0.75rem",
    width: "100%",
    fontSize: "0.8rem",
    lineHeight: 1.25,
    color: "#55595c",
    backgroundColor: "#fff",
    backgroundImage: "none",
    backgroundClip: "padding-box",
    borderTop: "0",
    borderRight: "0",
    borderBottom: "1px solid #eee",
    borderLeft: "0",
    borderRadius: "3px",
    transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)"
}


  return (
    <div>
        <form >
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} fullWidth>
            <DialogTitle id="customized-dialog-title" onClose={handleClose} style={{paddingLeft: '20px', color: 'white'}}>
            {currentId? 'Edit Product' : 'Add New Product'}
            </DialogTitle>
            <DialogContent dividers>


            <div className="customInputs">
              <input 
                placeholder="Brand" 
                style={inputStyle} 
                name='brand' 
                type='text'  
                onChange={(e) => setProductData({...productData, brand: e.target.value})}
                value={productData.brand} 
              />

              <input 
                placeholder="Model Number" 
                style={inputStyle} 
                name='modelNumber' 
                type='text' 
                onChange={(e) => setProductData({...productData, modelNumber: e.target.value})}
                value={productData.modelNumber}
              />

              <input 
                placeholder="Cost" 
                style={inputStyle} 
                name='cost'
                type='text'
                onChange={(e) => setProductData({...productData, cost: formatDollarsToCents(e.target.value)})}
                defaultValue={productData.cost !== '' ? dollar_formatter.format(formatCentsToDollars(productData.cost)) : productData.cost}
              />
              
            <input 
                placeholder="Price" 
                style={inputStyle} 
                name='price' 
                type='text'  
                onChange={(e) => setProductData({...productData, price : formatDollarsToCents(e.target.value)})}
                defaultValue={productData.price !== '' ? dollar_formatter.format(formatCentsToDollars(productData.price)) : productData.price} 
              />

              <input 
                placeholder="Type" 
                style={inputStyle} 
                name='type' 
                type='text' 
                onChange={(e) => setProductData({...productData, type: e.target.value})}
                value={productData.type} 
              />

              <input 
                placeholder="Description" 
                style={inputStyle} 
                name='description' 
                type='text' 
                onChange={(e) => setProductData({...productData, description: e.target.value})}
                value={productData.description} 
              />
          </div>

            </DialogContent>
            <DialogActions>
            <Button  onClick={handleSubmitProduct}  variant="contained" style={{marginRight: '25px'}} >
                Save 
            </Button>
            </DialogActions>
      </Dialog>
        </form>
    </div>
  );
}

export default AddProduct
